export { default as getDashboard } from './getDashboard';



// WEBPACK FOOTER //
// ./src/services/api/targetCheck/index.ts